export default __webpack_public_path__ + "static/media/glass_others.e4693660.JPG";